import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import { SEGMENT_BY_SLUG } from "@/lib/segments";
import SegmentRoute from "@/pages/SegmentRoute";

export const Route = createFileRoute("/agente-ia-loteadora-incorporadora")({
  head: () => buildHead({
    title: SEGMENT_BY_SLUG["agente-ia-loteadora-incorporadora"]!.metaTitle,
    description: SEGMENT_BY_SLUG["agente-ia-loteadora-incorporadora"]!.metaDescription,
    path: "/agente-ia-loteadora-incorporadora",
  }),
  component: () => <SegmentRoute slug="agente-ia-loteadora-incorporadora" />,
});
